import Vue from 'vue';
import visibility from 'vue-visibility-change';
 
// registry directive
Vue.use(visibility);
 
export default visibility
